import AppDispatcher from '../../utils/AppDispatcher';
import NotificationActions from '../../actions/NotificationActions';
import GuestListActions from '../../actions/GuestListActions';
import GuestActions from '../../actions/GuestActions';
import PopupActions from '../../actions/PopupActions';
import PosCartActions from '../../actions/PosCartActions';

import UserStore from '../../stores/UserStore';
import GuestListStore from '../../stores/GuestListStore';

import AjaxPromises from '../../utils/AjaxPromises';
import { endPoints as GuestEndPoints } from '../../constants/GuestConstants';
import { endPoints as PosCartEndPoints } from '../../constants/PosCartConstants';
import { endPoints as PosEndPoints, actions as ActionTypes } from '../../constants/PosConstants';

import Input from '../form/input/Input.react';

class ChangeStatus extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            visible : false,
            loading : false,
            status : this.props.guest.TransactionStatus,
            transactionReference : this.props.guest.TransactionReference,
            statusList : GuestListStore.getState().statusList
        }

        this.assignGuestToStatus = this.assignGuestToStatus.bind(this);
        this.checkout = this.checkout.bind(this);
        this.updateTransactionReference = this.updateTransactionReference.bind(this);
        this.updateStatusAndReference = this.updateStatusAndReference.bind(this);
    }

    assignGuestToStatus(status) {
        if (this.state.loading)
            return;

            var { guest } = this.props;

        if (status !== 'Completed') {
            AjaxPromises.POST(GuestEndPoints.SET_STATUS, UserStore.getApiData({
                TransactionStatus : status,
                TransId : guest.ShipmentId
            })).then(res => {
                NotificationActions.addNotification({
                    type : res.Result ? 'success' : 'error',
                    body : res.Result ? ('Status Updated to '+status) : 'Status Update Failed'
                });
                if(UserStore.getState().selectedLocation.UseSmartCheckin){
                    const guestUpdated = {
                        Guest_id: guest.Guest_id,
                        TransactionStatus: status
                    };
                    GuestListActions.addOrUpdateGuest(guestUpdated);
                }else{
                    GuestListActions.loadGuestList(false);
                }    
                GuestActions.loadFullGuest(guest.Guest_id);
                PosCartActions.loadUserCart(guest.Guest_id, guest.ShipmentId);

                PopupActions.close();
                }
            );
        } else {
            this.checkout();
        }
    }

    checkout() {
        var self = this;
        var guest = this.props.guest;

        this.setState({ loading : true }, () => {
            AjaxPromises.POST(PosCartEndPoints.CART_SUMMARY, UserStore.getApiData({
                ShipmentId : this.props.guest.ShipmentId
            })).then(res => {
                if (res.Result) {
                    AjaxPromises.POST(PosEndPoints.CHECKOUT, UserStore.getApiData({
                        ShipmentId     : guest.ShipmentId,
                        MJStateIDNo    : guest.MJStateIDNo,
                        TotalItems     : res.Data[0].TotalItems,
                        DiscountAmt    : res.Data[0].DiscountedAmt,
                        TaxAmt         : res.Data[0].TaxAmt,
                        CheckPaid      : res.Data[0].CheckPaid,
                        CCPaid         : res.Data[0].CCpaid,
                        UserId         : UserStore.getState().user.userId,
                        TerminalId     : UserStore.getState().selectedRegister.id,
                        DebitPaid      : res.Data[0].DebitPaid,
                        TotalCharges   : res.Data[0].TotalCharges,
                        PaidAmt        : res.Data[0].PaidAmt,
                        DueCustomer    : res.Data[0].DueCustomer,
                        TransType      : res.Data[0].TransType,
                        TransId        : res.Data[0].TransId,
                        SubTotal       : res.Data[0].SubTotal,
                        NetAmt         : res.Data[0].NetAmt,
                        TaxRt          : res.Data[0].TaxRt
                    })).then(res => {
                        if (res.Result) {
                            self.setState({ visible : false }, () => {
                                NotificationActions.success('Guest checked out successfully');
                                GuestListActions.loadGuestList();
                            });
                        } else if(!res.Result) {
                            this.setState({ loading : false }, () => {
                                NotificationActions.error(`Unable to check out guest: ${res.Message}`);
                            });
                        }
                    });
                } else {
                    self.setState({ loading : false }, () => {
                        NotificationActions.error('Could not load Cart Summary');
                    });
                }
            });
        });
    }

    updateTransactionReference() {
        let data = {
            ShipmentId: this.props.guest.ShipmentId,
            TransactionReference : this.state.transactionReference
        };

        AjaxPromises.POST(PosEndPoints.UPDATE_TRANSACTION_REF, UserStore.getApiData(data)).then(res => {
            if (res.Result) {
                NotificationActions.success('Transaction reference updated.')
                if(!UserStore.getState().selectedLocation.UseSmartCheckin){
                    GuestListActions.loadGuestList(false);
                }

                AppDispatcher.dispatch({
                    actionType: ActionTypes.TRANSACTION_REFERENCE_UPDATED,
                    data
                });
                PopupActions.close();
            } else {
                NotificationActions.apiError('Could not update transaction reference updated.', res)
            }
        });
    }

    updateStatusAndReference() {
        this.assignGuestToStatus(this.state.status);
        this.updateTransactionReference();
    }

    render() {
        var guest = this.props.guest;
        return (
            <div className='popup popup__transparent'>
                <div className='popup__content change-status'>

                    <div className='popup-header'>
                        CHANGE STATUS

                        <div
                            className='popup-close'
                            onClick={() => { PopupActions.close(); }}>

                            <i className='fa fa-times' aria-hidden='true' />
                        </div>
                    </div>

                    <select
                        value={this.state.status}
                        className='input-text-1'
                        style={{
                            'width':'90%',
                            'marginTop':20
                        }}
                        onChange={e => { this.setState({ status : e.target.value }); }}
                        disabled={this.props.loading}>

                        <option value=''>No Status</option>

                        { this.state.statusList.map(x => {
                            return (
                                <option
                                    value={x.POSStatus}
                                    key={x.POSStatus}>

                                    {x.POSStatus}
                                </option>
                            );
                        })}

                        { guest.IsPaid &&
                            <option value='Completed'>Completed</option>
                        }
                    </select>

                    <Input
                        value={this.state.transactionReference}
                        style={{'width':'90%'}}
                        placeholder='Transaction Reference'
                        onChange={transactionReference => { this.setState({ transactionReference }); }} />

                    <div className='change-status__line' />

                    <div
                        className='btn-green'
                        style={{
                            'float':'right',
                            'marginRight':20,
                            'marginTop':10
                        }}
                        onClick={this.updateStatusAndReference}>
                        Update
                    </div>
                </div>
            </div>
        );
    }
}

export default ChangeStatus;


// WEBPACK FOOTER //
// ./ui_src/app/components/popup/ChangeStatus.react.jsx